import { getData, postData, patchData, deleteData } from '../utils/api';

// Get all sub-categories with pagination and filters
export const getSubCategories = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    sortField = 'displayOrder',
    sortValue = 'ASC',
    categoryId = '',
    isActive = '',
    searchKey = ''
  } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sortField,
    sortValue,
    ...(categoryId && { categoryId }),
    ...(isActive && { isActive }),
    ...(searchKey && { searchKey })
  });

  return getData(`/data/sub-category?${queryParams.toString()}`);
};

// Get single sub-category by ID or slug
export const getSubCategoryById = async (id) => {
  return getData(`/data/sub-category/${id}`);
};

// Create a new sub-category
export const createSubCategory = async (subCategoryData) => {
  const { categoryId, name, description, isActive = true, displayOrder = 0 } = subCategoryData;
  
  const requestData = {
    categoryId,
    name,
    description,
    isActive,
    displayOrder
  };
  
  return postData('/data/sub-category', requestData);
};

// Update an existing sub-category
export const updateSubCategory = async (subCategoryData) => {
  const { subCategoryId, categoryId, name, description, isActive, displayOrder } = subCategoryData;
  
  const updateData = { subCategoryId };
  
  if (categoryId !== undefined) updateData.categoryId = categoryId;
  if (name !== undefined) updateData.name = name;
  if (description !== undefined) updateData.description = description;
  if (isActive !== undefined) updateData.isActive = isActive;
  if (displayOrder !== undefined) updateData.displayOrder = displayOrder;

  return patchData('/data/sub-category', updateData);
};

// Delete a sub-category
export const deleteSubCategory = async (subCategoryId) => {
  return deleteData('/data/sub-category', {
    data: { subCategoryId }
  });
};

export default {
  getSubCategories,
  getSubCategoryById,
  createSubCategory,
  updateSubCategory,
  deleteSubCategory
};

